export const POPUP_CLASS = 'mapboxgl-popup--mouse-on-popup';

export const CITY_ZOOM = 12;

export const HOTELS_LAYERS = ['hotels-visited', 'hotels-active'];

export const REGIONS_LAYER = 'placeprices_regions';
